import React from 'react'
import { FormControl, Select, MenuItem, makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux';
import { changeLang } from '../redux/ducks/appDuck';
const useStyles = makeStyles((theme) => ({
  langPicker:{
    color:'white',
  }
}))
export default function LangChangeSelect(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const langChangeHandler = e => {
        dispatch(changeLang(e.target.value))
    }
    let app = useSelector(state => (state.app));

    let variant = props.variant === "" ? "" : "outlined";

    return (
        <FormControl variant={variant}>            
        <Select
          disableUnderline
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"              
          onChange={langChangeHandler}  
          value={app.lang} 
          className={classes.langPicker}           
        >
          <MenuItem value={'en'}>English</MenuItem>
          <MenuItem value={'zhTW'}>繁中</MenuItem>
          <MenuItem value={'zhCN'}>简中</MenuItem>
        </Select>
      </FormControl>
    )
}